'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var IconButton_module = require('./IconButton.module.css.js');
var clsx = require('clsx');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const IconButton = _ref => {
  let {
    hover = false,
    onClick,
    onMouseEnter,
    onMouseLeave,
    onFocus,
    children,
    onBlur,
    ariaLabel = 'clickable icon',
    'data-test': dataTest = null
  } = _ref;
  const classes = clsx__default["default"]({
    [IconButton_module["default"].iconButton]: true,
    [IconButton_module["default"].iconButtonHover]: hover
  });
  return /*#__PURE__*/React__default["default"].createElement("button", {
    className: classes,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onFocus: onFocus,
    onClick: onClick,
    onBlur: onBlur,
    "aria-label": ariaLabel,
    "data-test": dataTest
  }, children);
};

exports["default"] = IconButton;
